export var TextDecorator = /*#__PURE__*/ function(TextDecorator) {
    TextDecorator["TEXT_DECORATOR_UNKNOWN"] = "TEXT_DECORATOR_UNKNOWN";
    TextDecorator["EMPHASIS"] = "EMPHASIS";
    TextDecorator["STRIKE_THROUGH"] = "STRIKE_THROUGH";
    TextDecorator["UNDERLINE"] = "UNDERLINE";
    return TextDecorator;
}({});
